import { useDisclosure } from "@mantine/hooks";
import { OrganizationsModel } from "../../model/OrganizationsModel";
import { useEffect, useState } from "react";
import Repository from "../../_base/helper/HttpHelper";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { hasLength, useForm } from "@mantine/form";
import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  FileButton,
  Flex,
  Grid,
  Group,
  Image,
  LoadingOverlay,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import {
  getBranchSelect,
  getDepartmentSelect,
  getRoleSelect,
} from "../../const/getSelectApi";
import {
  IconWindow,
  IconCheck,
  IconUpload,
  IconTrash,
} from "@tabler/icons-react";
import { repositorySign } from "../../_base/_const/_constVar";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { TblDepartmentModel } from "../../model/TblDepartmentModel";
import { uploadFile } from "../../_base/extension/Extension";
import { UserModel } from "../../model/UserModel";
import { ImageCore } from "../Flow-step/ImageCore";

const UserChangPass = ({ onClose, id }: OrganizationCreateViewProps) => {
  const [visible, { close, open }] = useDisclosure(false);

  const handleCreateDepartment = async (payload: UserModel) => {
    open();

    let url = "/api/v1/Users/create";
    let callApi = await repositorySign.post<MessageResponse<boolean>>(
      url,
      payload
    );

    if (callApi?.httpStatusCode === 200) {
      if (callApi?.success) {
        await onClose();
        modals.closeAll();
        NotificationExtension.Success("Thành công !");
      } else NotificationExtension.Fails("Thất bại !");
    }

    close();
  };

  const [imageUrl, setImageUrl] = useState<string | null>("");

  return (
    <>
      <Box component="form" mx="auto">
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        ></LoadingOverlay>
        <TextInput
          label="Mật khẩu mới"
          onChange={(e) => {
            setImageUrl(e.target.value);
          }}
        ></TextInput>

        <Group mt={20} flex={20} justify="end">
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="button"
            color="blue"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
            onClick={async () => {
              const url = "/api/v1/users/update-pass";
              const result = await repositorySign.post<
                MessageResponse<boolean>
              >(url, {
                userId: id,
                pass: imageUrl,
              });
              if (result && result.httpStatusCode === 200) {
                if (result.success) {
                  await onClose();
                  NotificationExtension.Success("Thành công !");
                  modals.closeAll();
                } else
                  NotificationExtension.Fails(
                    result.message.length > 0 ? result.message : "Thất bại !"
                  );
                //   setDisabledBtn(false);
              }
            }}
          >
            Lưu
          </Button>
        </Group>
      </Box>
    </>
  );
};

type OrganizationCreateViewProps = {
  onClose: any;
  id: number;
};

export default UserChangPass;
